// Returns the segmentBy to fall back to when `segmentBy` isn't available for
// the given date range (mirrors TimeRangeFilter's disabled options), or null
// when the current segmentBy can stay.
export default function adjustSegmentBy(dateRangeId, segmentBy) {
  if (['all'].includes(dateRangeId) && ['day', 'week'].includes(segmentBy)) {
    return 'month'
  } else if (['ytd', 'last_year', '365d'].includes(dateRangeId) && ['day'].includes(segmentBy)) {
    return 'week'
  } else if (['ytd', 'last_year', '365d'].includes(dateRangeId) && ['year'].includes(segmentBy)) {
    return 'month'
  } else if (['90d'].includes(dateRangeId) && ['year'].includes(segmentBy)) {
    return 'week'
  } else if (['30d'].includes(dateRangeId) && ['year', 'month'].includes(segmentBy)) {
    return 'week'
  } else if (['7d', '14d'].includes(dateRangeId) && ['week', 'month', 'year'].includes(segmentBy)) {
    return 'day'
  }

  return null
}
